import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import Checkbox from "../../../common/Checkbox";
import Swal from "sweetalert2";

function QualityPriceUpdateModal({ title, id, onClose, handleView, originRows }) {
  const appStore = useContext(AppContext);
  const [inputs, setInputs] = useState({
    yyyy_mm:'',
    quality_price: 0
  });

  useEffect(() => {
      // Mount 될때만 실행된다.
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleInitSelect = () => {
    setInputs({
      yyyy_mm: originRows[0].yyyy_mm,
      quality_price: originRows[0].quality_price
    });

  }

  const handleSave = (event) => {
    let msg = '';
    if(inputs.quality_price === '' || inputs.quality_price === 0){
      msg = '품질비용은 필수로 작성해주세요.';
    }else if(Number(inputs.quality_price) <= 0){
      msg = '품질비용은 양수로만 작성해주세요.';
    }else{
      
      axios.post("/api/p/QualityPrice/Update", new URLSearchParams({
        yyyy_mm:inputs.yyyy_mm,
        quality_price:inputs.quality_price
     }),
     { withCredentials: true })
     .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '품질 비용 작성 완료',
            text: '정상적으로 품질 비용이 작성 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleView();
          });
         }else{
          appStore.capture();
         }
     })
     .catch(function (error) {
         appStore.capture();
     });
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">품질 비용 작성 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">년도</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="년도" value={inputs.yyyy_mm} name="dept_sort" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">품질비용<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="number" placeholder="품질비용" value={inputs.quality_price} name="quality_price" onChange={(e) => onChange(e) } style={{textAlign:'right', float: 'right'}} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      <div className="modal_button">
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                      <div className="modal_button">
                        <Button 
                          onClick={handleSave}
                          className="btn-p btn-u"
                          sx={{  
                              m: 1, 
                              fontSize: 18, 
                              color: "white", 
                              borderColor: "#FF3636", 
                              backgroundColor: "#FF3636",
                              ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                          }} 
                          variant="outlined">
                          작성
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default QualityPriceUpdateModal;